<template>
  <div class="protocol" :class="{'protocol-ac': ac}">
    <header-component
            :is-soon="false"
            img-left="/trocachip/img/setinha-left-preto.svg"
            img-right="/trocachip/img/access.svg"
            class="header-component"
    />
    <!-- body -->
    <div class="protocol_body">
      <div class="mobile-container">
        <h2 class="protocol_title">Digite o número do protocolo de atendimento</h2>
        <p class="protocol_subtitle">Caso não tenha o número do protocolo, fale com nossa Central de Atendimento através do 1056.</p>
        <!-- form -->
        <div class="protocol_form">
          <TextInput
                  label="Número do Protocolo"
                  placeholder="000000000"
                  :max-length="18"
                  v-model.trim="protocolInputValue"
                  :error="protocolInputErrorMessage"
          />
        </div>
        <!-- end form -->
      </div>
    </div>
    <div :class="{ 'background-desktop-black': ac, 'background-desktop': !ac }"></div>
    <!-- end body -->
    <!-- footer -->
    <div class="protocol_footer">
      <div class="mobile-container">
        <div class="protocol_footer_button">
          <action-button
                  theme="dark_full"
                  @click="onClickAdvance"
                  :disabled="AdvanceButtonDisabled"
          >Continuar</action-button>
        </div>
      </div>
    </div>
    <!-- end footer -->
    <!-- error alert -->
    <alert
            :danger="true"
            :description="alertDescription"
            :message="alertMessage"
            @close="onCloseErrorAlert"
            v-if="alertActive"
    />
    <!-- end error alert -->
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import ActionButton from '@/components/ActionButton'
  import Alert from '@/components/Alert'
  import HeaderComponent from '@/components/HeaderComponent'
  import TextInput from '@/components/form/TextInput'
  import ChangeService from '../services/change'
  import trackEvent from '@/services/trackEvent'

  export default {
    components: {
      ActionButton,
      Alert,
      HeaderComponent,
      TextInput
    },
    data() {
      return {
        protocolInputValue: '',
        protocolInputError: false,
        protocolInputErrorMessage: '',
        protocolInputFilled: false,
        submitting: false,
        alertDescription: '',
        alertMessage: '',
        alertActive: false,
        invalidProtocol: false
      }
    },
    computed: {
      ...mapState({
        ac: state => state.ac,
        customer: state => state.customer,
        protocol: state => state.protocol,
      }),
      AdvanceButtonDisabled() {
        return (
                !this.protocolInputFilled
                || this.protocolInputError
                || this.submitting
        )
      }
    },
    watch: {
      protocolInputValue() {
        this.onChangeProtocolInputValue();
      }
    },
    methods: {
      restoreDataFromStore() {
        this.protocolInputValue = this.protocol
      },
      saveDataToStore() {
        this.$store.dispatch('protocol', this.protocolInputValue)
      },
      validateProtocolInput() {
        if (this.protocolInputValue.length === 0) {
          this.protocolInputError = true
          this.protocolInputErrorMessage = 'O número do protocolo é obrigatório'
        } else {
          this.clearProtocolInputError()
        }
      },
      clearProtocolInputError() {
        this.protocolInputError = false
        this.protocolInputErrorMessage = ''
      },
      sendProtocol() {
        return ChangeService.protocol(this.protocolInputValue);
      },
      advance() {
        this.$router.push({
          name: 'authenticity-check',
          params: {
            step: '1'
          }
        })
      },
      validate() {
        this.validateProtocolInput()
        if (this.protocolInputError) {
          return false
        } else {
          return true
        }
      },
      async submit() {
        this.submitting = true

        await ChangeService.validateProtocol(this.protocolInputValue).then( response => {
          if (response.data.internalCode != 1) {
            this.onSendProtocolError(response.data);
            this.showAlert(response.data.dscErro, response.data.errorDescription)
            this.invalidProtocol = true
            return this.submitting = false
          }
        })

        if(this.invalidProtocol) return;

        if (this.validate()) {
          this.sendProtocol()
              .then((response) => {
                    if (response.data.internalCode == '1') {
                      this.saveDataToStore();
                      this.advance()
                    } else {
                      this.onSendProtocolError(response.data);
                    }
                  })
                  .catch((error) => {
                    this.onSendProtocolError(error.response.data);
                  });
        } else {
          this.submitting = false
        }
      },
      showAlert(description, message) {
        this.alertDescription = description
        this.alertMessage = message
        this.alertActive = true
      },
      hideAlert() {
        this.alertDescription = ''
        this.alertMessage = ''
        this.alertActive = false
      },
      trackAdvance() {
        trackEvent.track({
          'user.login': this.customer.login,
          'user.loginType': this.customer.loginType,
          'user.lineType': this.customer.lineType,
          'user.segment': this.customer.segment,
          'user.subSegment':  this.customer.subSegment,
          'user.planCode':  this.customer.planCode,
          'user.planName':  this.customer.planDesc,
          'channel': trackEvent.getChannel(),
          'event-category': 6,
          'event-label': 'Perda Roubo Defeito Digite Protocolo',
          'event-value': '',
          'event-status': 'Sucesso',
          'event-interactionNumber': '',
          'event-error': '',
          'event-errorDetail': ''
        })
      },
      onSendProtocolError(responseData) {
        this.submitting = false
        this.showAlert(responseData.desc, responseData.message)
      },
      onClickAdvance() {
        this.trackAdvance()
        this.submit()
      },
      onChangeProtocolInputValue() {
        if (this.protocolInputValue.length > 0) {
          this.protocolInputFilled = true
        } else {
          this.protocolInputFilled = false
        }

        if (this.protocolInputError) {
          this.clearProtocolInputError()
        }
      },
      onCloseErrorAlert() {
        this.hideAlert()
      }
    },
    created() {
      this.restoreDataFromStore()
    }
  };
</script>

<style lang="scss" scoped>
  .protocol {
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    min-height: 100%;
    padding-top: 96px;
    box-sizing: border-box;
    background-color: #FFFFFF;
  }

  .protocol-ac.protocol {
    background-color: #1c1c1c;
  }

  .protocol_body {
    flex: 1;
  }

  .protocol_title {
    display: block;
    margin: 0;
    padding: 0;
    color: #181818;
    text-align: center;
    font-family: timsans_thin;
    font-size: 1.75rem;
    line-height: normal;
  }

  .protocol-ac .protocol_title {
    color: #FFFFFF;
  }

  .protocol_subtitle {
    display: block;
    margin: 20px 0 0 0;
    padding: 0;
    color: #808080;
    text-align: center;
    font-family: timsans_regular;
    font-size: 0.9375rem;
    line-height: normal;
  }

  .protocol-ac .protocol_subtitle {
    color: #FFFFFF;
  }

  .protocol_form {
    margin-top: 72px;
  }

  .protocol_footer {
    padding-top: 40px;
    padding-bottom: 40px;
  }

  .protocol_footer_button {}

  @media (min-width: 768px) {
    .protocol {
      display: grid;
      grid-auto-columns: 50% 50%;
      grid-template-areas:
                    'header header'
                    'body background'
                    'footer background'
    ;
      position: absolute;
      padding-top: 0;
    }

    .header-component {
      width: 45%;
      grid-area: header;
    }

    .protocol-ac.protocol {
      background-color: #1c1c1c;
    }

    .mobile-container {
      width: 400px;
      max-width: 400px;
    }

    .protocol_body {
      grid-area: body;
      margin-top: 139px;
    }

    .background-desktop {
      grid-area: background;
      width: 100%;
      height: 100vh;
      flex: 1;
      background: url("../assets/images/desktop@3x.png") no-repeat;
      background-size: cover;
    }

    .background-desktop-black {
      grid-area: background;
      width: 100%;
      height: 100vh;
      display: block;
      background: url("../assets/images/desktop-black.png") no-repeat;
      background-size: cover;
    }

    .protocol_title {
      width: 400px;
      display: block;
      margin: 0;
      padding: 0;
      color: #181818;
      text-align: center;
      font-family: timsans_thin;
      font-weight: 300;
      font-size: 2rem;
      line-height: normal;
    }

    .protocol-ac .protocol_title {
      color: #FFFFFF;
    }

    .protocol_subtitle {
      display: block;
      margin: 20px 0 0 0;
      padding: 0;
      color: #808080;
      text-align: center;
      font-family: timsans_regular;
      font-size: 0.9375rem;
      line-height: normal;
    }

    .protocol-ac .protocol_subtitle {
      color: #FFFFFF;
    }

    .protocol_form {
      margin-top: 72px;
    }

    .protocol_footer {
      width: 100%;
      grid-area: footer;
      padding-top: 40px;
      padding-bottom: 40px;
    }

    .protocol_footer_button {}
  }
</style>
